module.exports = __webpack_public_path__ + "static/media/outcomes.c2035263.svg";